import React from 'react';
import ReactDOM from 'react-dom';
import FormItemEnumEditor from './FormItemEnumEditor';
import EditorForDataGridMix from './EditorForDataGridMix';
import RecordsActions from '../actions/RecordsActions';
import {SwitchToCurrentSetSelectStore} from '../stores/FocusStore';
import {DsAllowEditStore} from '../stores/CmdTypeStore';
import FormItemConst from './FormItemConst';
require("../styles/FormItemEnumStyle.css");
require("../styles/bootstrap-select.css");
require("bootstrap-select");

export default class FormItemEnumEditorForDataGrid extends EditorForDataGridMix(FormItemEnumEditor)
{

	lookupStates = 
	{
		isShowed:false
	}

	registerStores()
	{
		//this.unsubcribeSwitchToCurrentSetSelectStore = SwitchToCurrentSetSelectStore.listen(this.switchToCurrentSetSelectedHandler.bind(this));
		this.unsubscribeDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
	}


	// var A = function(params) {
		
	// }
	// var a = new A();
	// a.c = function(){alert("b")}
	// A.prototype.c = function(){
	// 	alert("c");
	// }

	// a.c();
	componentWillUnmount()
	{
		
		//this.unsubscribeRecordFieldChangeStore();
		this.unsubscribeDsAllowEditStore();
	}

	onDsAllowEditStore(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			let finalValue = this.props.control.getProperty_AllowEdit_Final();

			this.doSetEnable(finalValue);	
		}
		
	}


	getValue(): any {
	    let updated = {};
	    let _val = this.getInputNode().value+"";
		updated[this.props.column.key] = _val;
		this.justCommit = true;
	    if(this.props.value != updated[this.props.column.key])
	    {
	    	RecordsActions.RecordFieldChanged(this.props.rowData,this.props.column.key,this.props.value,updated[this.props.column.key],this);
	    	if(this.props.control)
	    	{
				let result;
				if(this.props.column.isdynamic == true)
				{
					result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName,_val,this.props.value+"",null,null,{dynamicColumn:true,dynamicKey:this.props.column.dynamicFieldLabel});
				}
				else
				{
					let _oldValue = this.props.value;
					result = this.props.control.doFieldModifiedRemote(this.props.column.key,_val,_oldValue+"");
				}
				
	    		if(!result && !this.props.control.isDataMethodField)
	    		{
	    			return {};
	    		}
				if(result && !this.props.control.isDataMethodField){
					if(this.props.rowData[this.props.column.key] !=this.props.value && this.props.rowData[this.props.column.key]!=_val){
						_val = this.props.rowData[this.props.column.key];
						updated[this.props.column.key] = _val;
					}
				}
	    	}
	    }
	    return updated;
	}

	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{

	}

	//项目编辑器只在销毁时回送数据
	selectedChanged()
	{

	}

	/*componentDidMount()
	{
		//super.componentDidMount();
		
		
		$(this.inputField).selectpicker('val',this.props.value);
		$(this.inputField).parent().find("button.btn").keydown(this.onKeyDownHandler.bind(this));

		if(this.props.underQueryGroup)
		{
			this.doSetEnable(false);
		}
		else
		{
			this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias);
		}

		//this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias);
		if(!this.props.groupAlias)
		{
			this.doUpdateAllowEditByJquery(this.state.allowEdit);
		}
	}*/

	dropdownHideHandler()
	{
		this.lookupStates.isShowed = false;
		var elem = $(this.inputField).parent().find("button.btn");
		elem.focus();
		//setTimeout(function(){elem.focus();},100);
	}

	componentDidMount()
	{
		$(this.inputField).selectpicker({container:'body',liveSearch:false});
		$(this.inputField).selectpicker('val',this.props.value);
		let _lookupStates = this.lookupStates;
		$(this.inputField).on("show.bs.select",function(){_lookupStates.isShowed = true;});
		$(this.inputField).on("hide.bs.select",this.dropdownHideHandler.bind(this));
		let allowEdit = true;
		if(!allowEdit)
		{
			$(this.inputField).parent().find("button.btn")
				.css("background-color","#dddddd").css("cursor","not-allowed");
			$(this.inputField).attr("disabled","");
			$(this.inputField).parent().find("button.btn>span.pull-left").css("text-align","left");
		}
		var elem = $(this.inputField).parent().find("button.btn");
		
		setTimeout(function(){elem.focus();},100);

		if(this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
			this.doSetEnable(_allowEdit);
		}

		if(this.props.contextMenuData)
			$(this.inputField).contextPopup(this.props.contextMenuData);
	}

	//当有下拉框存在的时候 项目编辑器在失去焦点时不销毁
	//下拉框是否销毁由项目编辑器决定
	handleBlurCommit()
	{
		if(this.justCommit == true)
		{
			this.justCommit = false;return false;
		}
	   if(this.lookupStates.isShowed)
	   	return false;

	   if(arguments[0] && arguments[0].relatedTarget)
	   {
	   		if($(arguments[0].relatedTarget).isChildAndSelfOf($(this.inputField).parent()))
	   			return false;
	   }
	   

	   return true;
	}

	getInputNode() 
	{
	    return this.inputField;
    }

    doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("disabled")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			$(this.inputField).parent().find("button.btn")
				.css("background-color",FormItemConst.EDITOR_NOTEDIT_COLOR).css("cursor","not-allowed");
			$(this.inputField).attr("disabled","");
			//$(this.inputField).parent().find("button.btn>span.pull-left").css("text-align","left");
		}
		else if(nowAllowEdit == false && enable == true)
		{
			$(this.inputField).parent().find("button.btn")
				.css("background-color","#FFFFFF").css("cursor","pointer");
			$(this.inputField).removeAttr("disabled");
		}
	}

	componentDidUpdate()
  	{
  	}

  	componentWillUnmount()
  	{
  		$(this.inputField).selectpicker('destroy');
  		//this.unsubcribeSwitchToCurrentSetSelectStore();
  	}

	render()
	{
		let rowStyles = this.getRowStyles();
		let _style = {padding:'0px',width:'100%',height:'100%',paddingTop:'0px',backgroundColor:'#ffffff',cursor:'text'};
		if(rowStyles)
		{
			for(let i = 0;i<rowStyles.length;i++)
			{
				let rowStyle = rowStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
				if(bool)
				{
					if(rowStyle.color != -1)
						_style.color = "#"+rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(rowStyle.fontSize != -1)
						_style.fontSize = rowStyle.fontSize;
					if(rowStyle.fontFamily != null)
						_style.fontFamily = rowStyle.fontFamily;
					if(rowStyle.fontWeight != null)
						_style.fontWeight = rowStyle.fontWeight;
				}
			}
		}

		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
				if(bool)
				{
					if(colStyle.color != -1)
						_style.color = "#"+colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(colStyle.fontSize != -1)
						_style.fontSize = colStyle.fontSize;
					if(colStyle.fontFamily != null)
						_style.fontFamily = colStyle.fontFamily;
					if(colStyle.fontWeight != null)
						_style.fontWeight = colStyle.fontWeight;
				}
			}
		}

		let _options = this.props.options;
		if(this.props.xml.Properties.Regular.Value){
			let regular =  this.props.xml.Properties.Regular.Value;
			let enumv = regular.split('|');
			var _optionsN =[];
			enumv.forEach((eItem)=>{
				_options.forEach((item)=>{
					if(Number(item.value)== eItem){
						_optionsN.push(item);
					}
				})
			})
		}

		if(_optionsN){
			var list = _optionsN.map(function(item){
					return <option key={item.value} value={item.value}>{item.label}</option>;
			});
		}else{
			var list = _options.map(function(item){
				return <option key={item.value} value={item.value}>{item.label}</option>;
			});
		}
		return(
			
	          <select ref={ node => this.inputField = node } data-live-search="true" 
	          		  id={"select"+this.props.xml.id} className="FormItemEnumEditorForDataGrid selectpicker form-control" 
	          		  style={_style}
	          		  >
               	{list}
              </select>
		);
	}
}



// WEBPACK FOOTER //
// ./src/formItem/FormItemEnumEditorForDataGrid.js